import moment from "moment";
import { useStore } from "react-redux";
import { NotificationType } from "../types";

// Retrieve current progress status
export function GetProgressStatus(notification) {
  /*
   * Store, Props, Global Functions
   */
  // retrieve store
  const store = useStore().getState();

  let created = moment(notification.created);
  // either get date of progress started or date of now if no progress is made
  let progressstarted =
    notification.progressstarted > 0
      ? moment(notification.progressstarted)
      : moment();

  // show time since issue is open and unresolved (status 0: open, status 1: in progress)
  if (notification.status < 2) {
    let timeUnsolved = progressstarted.diff(created);

    // if time longer than 48h, show time range as days
    if (timeUnsolved < 172800000) {
      timeUnsolved = progressstarted.diff(created, "hours");
      return timeUnsolved + "h " + store.i18n.unresolved;
    } else {
      timeUnsolved = progressstarted.diff(created, "days");
      return timeUnsolved + " " + store.i18n.days + " " + store.i18n.unresolved;
    }
  }
}

// get related color/class of notifications
export function getTypeColor(type, scope) {
  if (typeof type !== "undefined") {
    let color = "";

    // get color depending on type
    switch (type) {
      case 0:
        color = "Red";
        break;
      case 1:
        color = "Yellow";
        break;
      case 2:
        color = "Gray";
        break;
      case 3:
        color = "Gray";
        break;
      case 4:
        color = "Gray";
        break;
      case 5:
        color = "Gray";
        break;
      case 6:
        color = "DarkMagenta";
        break;
      case 7:
        color = "Yellow";
        break;
      default:
        color = "Gray";
    }

    // get type class depending on scope
    switch (scope) {
      case "card":
        return { class: "cardStatus" + color };
      case "badge":
        return { class: "badgeStatus" + color };
      default:
        return color.toLowerCase();
    }
  } else {
    console.error("No type code defined!");
  }
}


// check if notifications contain notification that indicates a malfunction (type 0)
export function hasMalfunction(notifications) {
  let storungTypes = [0, 10, 11, 12];
  let hasMalfunction = false;

  if (notifications) {
    // TODO: define what means undisturbed? Is it really only code 0 or also code 1 ?
    const filter_notification = notifications;

    if (filter_notification.length > 0) {
      if (storungTypes.includes(filter_notification[0].notification.type)) {
        return "#FF3D00";
      } else if (filter_notification[0].notification.type === 1) {
        return "#FFB300";
      } else if (
        filter_notification[0].notification.type === 6 ||
        filter_notification[0].notification.type === 7
      ) {
        return "#039BE5";
      }
    }
  }

  return hasMalfunction;
}

// function to return notification type + date time in DD.MM.YYYY, HH:MM h
export function GetNotificationTypeDateTime(notificationData) {
  // retrieve context
  const store = useStore().getState();
  let appBarTitle = store.i18n.notificationtype_from.replace(
    "%notificationtype",
    NotificationType(Number(notificationData.notification.type))
  );
  return (
    appBarTitle.replace(
      "%datetime",
      moment(notificationData.notification.created).format("DD.MM.YY, HH:MM")
    ) + "h"
  );
}

export function GetNotificationTypeDate(notificationData) {
  // retrieve context
  const store = useStore().getState();
  let appBarTitle = store.i18n.notificationtype_from.replace(
    "%notificationtype",
    NotificationType(Number(notificationData.notification.type))
  );
  return appBarTitle.replace(
    "%datetime",
    moment(notificationData.notification.created).format("DD.MM.YYYY")
  );
}

export function GetNotificationTime(notificationData) {
  return moment(notificationData.notification.created).format("HH:mm") + " h";
}

export function GetTimeDate(notificationData) {
  const store = useStore().getState();
  return (
    moment(notificationData.created).format("HH:mm") +
    " " +
    store.i18n.time_h +
    ", " +
    moment(notificationData.created).format("DD.MM.YYYY")
  );
}
